module.exports = __webpack_public_path__ + "media/images/ui-icons_777620_256x240-252c1ed8daa4f1971824920328de21e0.png";